import { DefaultTheme } from "shared/theme/sidespor/types";
import { capitalize, keys } from "shared/theme/sidespor/utility";
import { darkTheme } from "shared/theme/sidespor/theme/darkTheme";
import { lightTheme } from "shared/theme/sidespor/theme/lightTheme";

export const SemanticsList = [
  "alarm",
  "secondaryAlarm",
  "warning",
  "info",
  "success",
  "neutral",
  "special",
  "ghost",
] as const;

export type Semantics = (typeof SemanticsList)[number];

type ColorTheme = typeof lightTheme & typeof darkTheme;

// Behaves just the same as `theme = useTheme()`, but the values are mapped to `semantics.${key}` instead
export const themeTokens = Object.fromEntries(
  keys(lightTheme).map((key) => [key, `semantics.${key}`]),
) as { [K in keyof ColorTheme]: `semantics.${K}` };

export type ThemeTokensSemantic = ColorTheme & {
  [K in keyof ColorTheme as K extends `${infer Prefix}${Capitalize<Semantics>}${infer Suffix}`
    ? `${Prefix}Semantic${Suffix}`
    : K]: string;
};

// Replaces "Semantic" (the string) with `semantics` (the argument) when retrieving values from `theme`
export const useThemeTokensSemantic = (semantics: Semantics) =>
  new Proxy(themeTokens, {
    get(target: DefaultTheme, property: string) {
      return target[property.replace("Semantic", capitalize(semantics))];
    },
  }) as ThemeTokensSemantic;
